import { AccordionHeaderTitle } from 'component/Accordion';
import { CheckboxInput } from 'component/Checkbox';
import { CategoryTranslations, EOFoundCategories } from 'consts/Daily';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { ReactComponent as ArrowDownSvg } from 'assets/images/icons/down-small.svg';
import { ReactComponent as ArrowUpSvg } from 'assets/images/icons/up-small.svg';
import { CommentBlock, CommentDisplay } from 'component/CommentBlock';
import { CategoryEvidences, CategoryEvidencesView } from './Categories';
import { TableData, TableDataView } from './TableData';
import { Summary } from './Summary';
import { HandOverSwitcher } from './HandOverSwitcher';
import { HandOverBlock, HandOverBlockView } from './HandOver/HandOver';
import { SET_CATEGORY_CHECKED, TOGGLE_EO_CATEGORY_ITEM, UPDATE_EO_FOUND_CATEGORIES } from 'reducers/dailyFormActions';

export const EOFoundBlock = ({ formData, dispatch, hasError, errors, eoFoundChoices }) => {
  const prevCategoriesRef = useRef(formData?.info?.eo_found_categories);

  useEffect(() => {
    const currentCategories = formData?.info?.eo_found_categories;
    const prevCategories = prevCategoriesRef.current;

    if (currentCategories && prevCategories !== currentCategories) {
      dispatch({
        type: UPDATE_EO_FOUND_CATEGORIES,
        payload: currentCategories
      });
    }
  }, [formData?.info?.eo_found_categories, dispatch]);
  return (
    <div className="rounded-bg-grey">
      <AccordionItemHeading>
        <AccordionItemButton>
          <AccordionHeaderTitle
            accordionId="3"
            block="battle-area-clearance"
            titleUA={(
              <div className="flex-group">
                <span className={hasError ? 'error-text' : ''}>Знайдено ВНП</span>
                <span className="star" />
              </div>
            )}
            titleEN="EO found"
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        {['mines', 'uxos', 'ied', 'saa'].map((category, index) => (
          <EOCategory
            formData={formData}
            dispatch={dispatch}
            category={category}
            key={`${category}-${index}`}
            eoFoundChoices={eoFoundChoices}
          />
        ))}
        <HandOverSwitcher
          formData={formData}
          dispatch={dispatch}

        />
        {formData?.info?.hand_over && (
          <HandOverBlock
            formData={formData}
            dispatch={dispatch}
          />
        )}
      </AccordionItemPanel>
    </div>
  );
};

export const EOCategory = ({ formData, dispatch, category, eoFoundChoices }) => {
  const [checkboxChecked, setCheckboxChecked] = useState(Boolean(formData
    ?.info?.eo_found_categories?.[category]?.evidences?.length) || false);

    const isChecked = formData?.info?.eo_found_categories?.[category]?.isChecked || false;

    useEffect(() => {
      const hasData = Boolean(formData?.info?.eo_found_categories?.[category]?.evidences?.length);
      if (hasData && !isChecked) {
        dispatch({
          type: SET_CATEGORY_CHECKED,
          payload: {
            category,
            isChecked: true
          }
        });
      }
    }, []);

    const handleCheckbox = () => {
      const newCheckedState = !isChecked;

      dispatch({
        type: SET_CATEGORY_CHECKED,
        payload: {
          category,
          isChecked: newCheckedState
        }
      });

      if (newCheckedState) {
        dispatch({
          type: TOGGLE_EO_CATEGORY_ITEM,
          payload: {
            category: category,
            checked: newCheckedState
          }
        });
      }
    };

  const subcategoriesWithData = useMemo(() => {
    const evidences = formData?.info?.eo_found_categories?.[category]?.evidences || [];
    const items = formData?.info?.eo_found_categories?.[category]?.items || [];

    const subcategoriesWithEvidence = new Set(
      evidences.map(evidence => evidence.item)
    );

    return items.filter(item =>
      subcategoriesWithEvidence.has(item.name) ||
      (item.count && item.count > 0)
    );
  }, [formData?.info?.eo_found_categories, category]);

  return (
    <div className="flex-column-group">
      <div className="flex-group">
        <CheckboxInput
          checked={isChecked}
          handleInput={handleCheckbox}
          label={CategoryTranslations[category][category]}
          value={category}
          id={category}
          name={category}
        />
        <span className="line" />
      </div>
      {isChecked && (
        <>
          <CategoryEvidences
            formData={formData}
            dispatch={dispatch}
            category={category}
            eoFoundChoices={eoFoundChoices}
          />
          {subcategoriesWithData?.map((item) => (
            <TableData
              key={item.name}
              formData={formData}
              dispatch={dispatch}
              category={category}
              subCategory={item.name}
              eoFoundChoices={eoFoundChoices}
            />
          ))}
          {formData?.info?.eo_found_categories?.[category] && (
            <Summary
              formData={formData}
              category={category}
            />
          )}
        </>
      )}
    </div>
  );
};

export const EOFoundBlockView = ({ formData, mode, commentsData, translatedFormData = {}, translateState = false, eoFoundChoices }) => {
  const {
    comments,
    commentForm,
    savedComment,
    commentEntered,
    onSaveComment,
    onDeleteComment,
    handleComments,
  } = commentsData;

  return (
    <div className="w-100 flex-column-group">
      <div className="rounded-bg-grey">
        <AccordionItemHeading>
          <AccordionItemButton>
            <AccordionHeaderTitle
              accordionId="3"
              block="battle-area-clearance"
              titleUA={(
                <div className="flex-group">
                  <span>Знайдено ВНП</span>
                  <span className="star" />
                </div>
              )}
              titleEN="EO found"
            />
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel className="flex-column-group gap-10">
          {['mines', 'uxos', 'ied', 'saa'].map((category) => (
            <EOCategoryView
              formData={formData}
              category={category}
              key={category}
              translatedFormData={translatedFormData}
              translateState={translateState}
              eoFoundChoices={eoFoundChoices}
            />
          ))}
          {formData?.info?.hand_over && (
            <HandOverBlockView
              handOverBlock={formData?.info?.hand_over_block}
              translatedFormData={translatedFormData}
              translateState={translateState}
            />
          )}
        </AccordionItemPanel>
      </div>
      {mode === 'validation' && (
        <CommentBlock
          comments={comments}
          savedComment={savedComment}
          commentForm={commentForm}
          commentEntered={commentEntered}
          block="eo_found"
          onDeleteComment={onDeleteComment}
          handleComments={handleComments}
          onSaveComment={onSaveComment}
        />
      )}
          {mode === 'view' &&
            <CommentDisplay comments={commentsData?.comments} block="eo_found" />}
    </div>
  );
};

export const EOCategoryView = ({ formData, category, translatedFormData = {}, translateState = false, eoFoundChoices }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const categoryData = formData?.info?.eo_found_categories?.[category] || {};
  const hasItems = categoryData?.items?.length > 0;
  const hasEvidences = categoryData?.evidences?.length > 0;
  const hasLinks = categoryData?.links?.length > 0;
  const hasData = hasItems || hasEvidences || hasLinks;

  return (
    <div className="flex-column-group">
    <div className="flex-group">
      <div className="double-text">
        <span>{eoFoundChoices?.[category]?.find(c => c.value === category)?.label || CategoryTranslations[category][category]}</span>
      </div>
      <span className="line" />
      {hasData && (
        <span
          className="text-hover"
          onClick={toggleExpand}
        >
          {isExpanded ? <ArrowUpSvg /> : <ArrowDownSvg />}
        </span>
      )}
    </div>
    {isExpanded && (
      <>
        <CategoryEvidencesView
          formData={formData}
          category={category}
          eoFoundChoices={eoFoundChoices}
        />
        {formData?.info?.eo_found_categories?.[category]?.items?.map((item) => (
          <TableDataView
            key={item?.name}
            formData={formData}
            category={category}
            subCategory={item?.name}
            translatedFormData={translatedFormData}
            translateState={translateState}
            eoFoundChoices={eoFoundChoices}
          />
        ))}
        {hasData && formData?.info?.eo_found_categories?.[category] && (
          <Summary
            formData={formData}
            category={category}
          />
        )}
      </>
    )}
  </div>
  );
};
